import { memo, useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import { ContactDeactivationStepProps } from '../../models'
import { contactDeactivationModalTranslations } from '../../translation'
import { ContactDeactivationHeader } from '../contactDeactivationHeader'

import styles from './ContactDeactivationFooter.module.scss'

export const ContactDeactivationFooter = memo<ContactDeactivationStepProps>(
  ({ onCancel, onProceed }) => {
    const [isConfirmDialogVisible, setConfirmDialogVisible] = useState(false)

    const handleCancel = useCallback(() => {
      setConfirmDialogVisible(true)
    }, [])

    const handleConfirmCancel = useCallback(() => {
      setConfirmDialogVisible(false)
    }, [])

    const renderContent = useCallback(
      () => (
        <>
          <ContactDeactivationHeader
            title={contactDeactivationModalTranslations.cancelConfirm.title}
            description={contactDeactivationModalTranslations.cancelConfirm.description}
          />
          <div className={styles.confirmButtons}>
            <Button onClick={onCancel} color="danger" variant="text">
              <Translation
                text={contactDeactivationModalTranslations.cancelConfirm.buttons.cancel}
                span
              />
            </Button>
            <Button onClick={handleConfirmCancel}>
              <Translation
                text={contactDeactivationModalTranslations.cancelConfirm.buttons.confirm}
                span
              />
            </Button>
          </div>
        </>
      ),
      [handleConfirmCancel, onCancel]
    )

    return (
      <div className={styles.buttons}>
        <Button onClick={handleCancel} color="danger" variant="text">
          <Translation
            text={contactDeactivationModalTranslations.welcomeStep.buttons.cancel}
            span
          />
        </Button>
        <Button onClick={onProceed}>
          <Translation
            text={contactDeactivationModalTranslations.welcomeStep.buttons.proceed}
            span
          />
        </Button>
        <ModalDialog
          classes={styles}
          size="sm"
          show={isConfirmDialogVisible}
          content={renderContent}
          onClose={handleConfirmCancel}
          closeOnOutsideClick={false}
        />
      </div>
    )
  }
)

ContactDeactivationFooter.displayName = 'ContactDeactivationFooter'
